import apiClient from '../api';

export const createTemplate = (data, header) => apiClient.post(`/template/add`, data, header);
export const getAllTemplates = ( header) => apiClient.get(`/template`, header);
export const updateTemplateById = (id, data, header) => apiClient.put(`/template/update/${id}`, data, header);

export const deleteTemplateById = (id, header) => apiClient.delete(`/template/delete/${id}`, header);

export const addSelectedTemplate = ( data, header) => apiClient.post(`/template/select`, data, header);
export const getOrganizationTemplateById = ( orgId, header) => apiClient.get(`/template/organization/${orgId}`, header);